import React from 'react';

export const MessageNoTimeAvailable = (): React.JSX.Element => (
  <>
    There are no upgrade slots available within the next 15 days.
    <br />
    Please try again later.
  </>
);
